import React from 'react';
import ReactDOM from 'react-dom/client';

import { AppProvider } from '@/app/AppProvider';
import App from '@/app/App';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import ReactGA from 'react-ga4';
import { initSentry } from '@/utils/sentry/instrument';

initSentry();

const oneAdvisorWeblGoogleAnalyticsKey = import.meta.env
  .VITE_ONE_ADVISOR_WEB_GOOGLE_ANALYTICS_KEY;
if (oneAdvisorWeblGoogleAnalyticsKey) {
  ReactGA.initialize(oneAdvisorWeblGoogleAnalyticsKey);
}

dayjs.extend(utc);
dayjs.extend(timezone);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDayjs} dateLibInstance={dayjs}>
      <AppProvider>
        <App />
      </AppProvider>
    </LocalizationProvider>
  </React.StrictMode>,
);
